<style>
</style>
<template>
  <div class="container">
    <div>
      <div id="loader-wrapper" v-if="cargando">
        <div id="loader"></div>
      </div>
      <div class="row ">
        <div class="form-group col-md-12">
          <div class="card card-wizard" id="wizardCard">
            <div class="row d-flex align-items-center m-0 p-0">
              <div class="col-md-8 p-0">
                <legend>Importar padrón de servidores públicos</legend>
              </div>
              <div class="col-md-4 p-2">
                <a target="_blanc" class="btn btn-wd btn-info pull-right" v-bind:href="$rootUrl+'/plantillac.xlsx'" alt="Plantilla XLSX">
                  <span class="btn-label">
                    <i class="fa fa-file-excel"></i>
                  </span>
                  Descargar Plantilla
                </a>
              </div>
            </div>
            <form action="" @submit.prevent="saveComprobante">
              <table class="table">
                <tbody>
                  <tr>
                    <td colspan="2">
                      <div class="row m-0 p-0">
                        <div class="col-12 m-0 p-0">
                          <div class="alert alert-warning mb-0">
                            <b>Todos los servidores públicos serán cargados con los parámetros seleccionados, verifique que sean correctos.</b>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="getKey('permisos').includes(5)">
                    <td align="right"> Dependencia</td>
                    <td>
                      <el-select class="select-default" name="ente_publico_id" placeholder="Seleccione una opción" filterable v-model="ente_publico_id">
                        <el-option v-for="option in entes" class="select-default" :value="option.id" :label="option.valor" :key="option.label"></el-option>
                      </el-select>
                    </td>
                  </tr>
                  <tr>
                    <td align="right">
                      Tipo de declaración
                    </td>
                    <td>
                      <p-radio class="d-inline-block" v-model="simplificada" label="0">Completa</p-radio>
                      <p-radio class="d-inline-block no" v-model="simplificada" label="1">Simplificada</p-radio>
                    </td>
                  </tr>
                  <tr>
                    <td align="right">
                      Declaración a realizar
                    </td>
                    <td>
                      <el-select clearable class="select-default" filterable name="tipo_dec" placeholder="Tipo declaración" v-model="tipo_dec">
                        <el-option v-for="option in tipo_declaracion" class="select-default" :value="option.id" :label="option.valor" :key="option.id+'tipo'">
                        </el-option>
                      </el-select>
                    </td>
                  </tr>
                  <tr>
                    <td align="right">
                      Periodo
                    </td>
                    <td>
                      <el-select clearable class="select-default" filterable name="periodo" placeholder="Periodo" v-model="periodo">
                        <el-option v-for="option in periodos" class="select-default" :value="option.year" :label="option.year" :key="option.year">
                        </el-option>
                      </el-select>
                    </td>
                  </tr>
                  <tr>
                    <td align="right">Seleccionar el grupo para cargar el padrón</td>
                    <td>
                      <select name="grupo" id="grupo" v-model="grupo" class="select-default">
                        <option value="1">Grupo 1</option>
                        <option value="2" selected>Grupo 2</option>
                        <option value="3">Grupo 3</option>
                      </select>
                    </td>
                  </tr>

                  <tr v-if="ente_publico_id || getKey('permisos').includes(5)===false ">
                    <td align="right">Seleccionar el archivo excel</td>
                    <td>
                      <input id="xlsx" ref="xlsx" accept=".xlsx" @change="addFile('xlsx')" required class="form-control" type="file">
                    </td>
                  </tr>
                  <tr v-if="grupo!=0 && xlsx!=0">
                    <td colspan="2" align="center">
                      <button ref="btnSave" class="btn btn-primary">
                        <i class="fa fa-send"></i> Guardar</button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </form>
            <h3 v-if="Object.entries(incorrectos).length > 0 " class="bg-info text-white" align="center">
              Los siguientes registros cuentan con errores, favor de corregirlos y volver a cargar la plantilla. No se ha cargado ningún registro.
            </h3>
            <b-table id="tbl_incorrectos" responsive hover :items="incorrectos" :fields="fields_list" v-if="Object.entries(incorrectos).length > 0 ">
              <!-- :fields="fields_list" -->
              <template slot="Renglon" slot-scope="data">
                <div>
                  <span>{{data.item.Renglon}}</span>
                </div>
              </template>
              <template slot="Columna" slot-scope="data">
                <div>
                  <span>{{data.item.Columna}}</span>
                </div>
              </template>
              <template slot="Nombre" slot-scope="data">
                <div>
                  <span>{{data.item.Nombre}}</span>
                </div>
              </template>
              <template slot="RFC" slot-scope="data">
                <div>
                  <span>{{data.item.RFC}}</span>
                </div>
              </template>
              <template slot="Mensaje" slot-scope="data">
                <div>
                  <span>{{data.item.Mensaje}}</span>
                </div>
              </template>
              <template slot="empty">
                <h5>No existen registros</h5>
              </template>
            </b-table>
            <table class="table" v-if="correctos>0">
              <tr>
                <td>El archivo se importó correctamente</td>
              </tr>
              <tr>
                <td>
                  <div class="alert alert-success" role="alert">
                    <label style="color:#212529">
                      {{this.correctos}} registros han sido importados correctamente
                    </label>
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    FormWizard,
    TabContent
  } from "vue-form-wizard";
  import "vue-form-wizard/dist/vue-form-wizard.min.css";

  import swal from "sweetalert2";
  export default {
    data() {
      return {
        rol: null,
        cargando: true,
        wizardModel: {},
        incorrectos: [],
        periodos: [],
        periodo: null,
        correctos: 0,
        grupo: 2,
        tipo_dec: 1,
        xlsx: 0,
        simplificadafl: false,
        entes: null,
        ente_publico_id: null,
        simplificada: '0',
        tipo_declaracion: [{
          'id': 1,
          'valor': 'Inicial',
        }, {
          'id': 2,
          'valor': 'Anual',
        }, {
          'id': 3,
          'valor': 'Final'
        }],
        fields_list: [{
            key: "Renglon",
            label: "Renglon",
            tdClass: "text-left"
          },
          {
            key: "Columna",
            label: "Columna(s)",
            tdClass: "text-left"
          },
          {
            key: "Nombre",
            label: "Nombre",
            tdClass: "text-left"
          },
          {
            key: "RFC",
            label: "RFC",
            tdClass: "text-left"
          },
          {
            key: "Mensaje",
            label: "Mensaje",
            tdClass: "text-left",
            formatter: "emptyFields"
          }
        ]
      };
    },
    components: {
      FormWizard
    },
    watch: {
      '$route': 'checkPermissions',
      'grupo': function (val) {
        if (val == 3) {
          this.simplificada = '1'
          this.simplificadafl = true
        } else
          this.simplificadafl = false
      },
      'simplificada': function (val) {
        if (val == '1')
          this.grupo = 3
        else
          this.grupo = 2
      },
    },
    methods: {
      checkPermissions() {
        let permiso = [13];
        if (!this.getKey('permisos').some(r => permiso.includes(r))) {
          localStorage.clear();
          this.$router.push('/login');
          this.$router.go();
        }
      },
      saveComprobante() {
        let preg = ""

        if (this.simplificada == '1') {
          preg = 'Éstos registros se agregaran para presentar la declaración simplificada'
        } else {
          preg = 'Éstos registros se agregaran para presentar la declaración completa en el grupo ' + this.grupo
        }
        this.Ask(preg + ", ¿desea continuar?",
          () => {
            this.cargando = true;
            //this.loadButton(this.$refs.btnSave);
            const formData = new FormData();
            formData.append("grupo", this.grupo);
            formData.append("ente_publico_id", this.ente_publico_id);
            formData.append("simplificada", this.simplificada);
            formData.append("tipo_dec", this.tipo_dec);
            formData.append("periodo", this.periodo);

            formData.append("xlsx", this.xlsx);
            this.$http.post("Excel", formData).then(
              response => {
                this.incorrectos = response.data.incorrectos;
                this.correctos = response.data.correctos;
                this.cargando = false;
              },
              error => {
                this.cargando = false;
                this.Err(error);
              }
            );
          }
        );
      },
      addFile(tipo) {
        this.xlsx = this.$refs.xlsx.files[0];
      },
      validateFirstStep() {
        return this.$refs.firstStep.validate();
      },
      validateSecondStep() {
        return this.$refs.secondStep.validate();
      },

      wizardComplete() {
        // we gather models from all steps into one model
        this.wizardModel = {
          ...this.$refs.datosPersonales.model,
          ...this.$refs.firstStep.model,
          ...this.$refs.DatosCurriculares.model,
          ...this.$refs.DatosConyuge.model,
          ...this.$refs.secondStep.model
        };
        swal("Good job!", "You clicked the finish button!", "success");
      },
      getPeriodos() {
        var v = this;
        this.$http.get("getPeriodos").then(
          response => {
            var anios = response.data.periodos;

            anios.forEach(y => {
              if (y.year) {
                this.periodos.push(y);
              }
            });
            this.periodo = this.periodos[0].year;
          },
          error => {
            this.StepError(error);
          }
        );
      },
    },
    created() {
      this.checkPermissions();
      this.getPeriodos();

      this.rol = this.getKey("grupo");

      this.$http.get("cat_ente_publico").then(
        response => {
          this.entes = response.data.entes_publicos;
        },
        error => {
          this.Err(error);
        }
      );
      //  console.log('a');
      this.cargando = false;
    }
  };

</script>
<style>
  .vue-form-wizard .wizard-icon-circle.tab_shape {
    background-color: #9a9a9a !important;
    color: white;
  }

  .radio label {
    margin-left: 30px !important;
  }

  .no {
    margin-left: 80px !important;
  }

  .checkbox,
  .radio {
    margin-bottom: 0px !important;
    margin-top: 0px !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Forms/Plantilla.vue